export default {
  searchIcon: 'w-25 h-15',
  checkBoxActive: 'checkbox-active',
  checkBoxInActive: 'checkbox-inactive',
  typoProdType: 'prod-type',
  hiddenClass: 'hidden',
  typoProdName: 'prod-name',
  plpConstDiv:
    'ml-0 md:ml-35 pr-10 font-HelveticaNeueLight text-16 leading-24 text-black float-left',
  productList: {
    mainWrapper: 'mb-30',
    hiddenClass: 'hidden',
    breadcrumbContainer:
      'breadcrumbContainer border-t-1 border-greyLine border-solid mt-30',
    buttonWrapper: 'text-center',
    filterContainer: 'sm:pt-20 sm:pb-40 md:py-20 inline-block w-full',
    button: 'ml-1',
    listWrapper: 'w-full flex flex-wrap prodListWrapper',
    listWrappers: 'w-full flex flex-wrap prodListWrapper div_anchors',
    buttonDiv:
      'font-HelveticaNeueLight text-16 text-grey text-left leading-24 float-left md:mb-0',
    filterText: 'ml-8',
    gridStyle: 'float-right md:float-none sm:w-full md:w-auto mb-20 md:mb-0',
    gridwrapper: 'float-right md:float-none',
    gridRightWrapper: 'float-right block md:flex items-center pr-15 md:pr-0',
    sortWrapper: '',
    sortText: 'ml-35 font-HelveticaNeueLight text-16 leading-24 text-black',
    sortFilter: 'inline-block rounded-full ml-0',
    sortOption:
      'w-24 pl-10 bg-white font-sans-roma text-base leading-19 text-black-lighter',
    loadMore: 'text-center mt-20',
    loadMoreButton: 'font-sans-bold mt-40 text-13 btn',
    spinner: {
      wrapper: 'fixed -translate-xy50 pin-t50 pin-l50 w-12 ml z-20',
    },
  },
  facet: {
    categoryTitleWrapper: 'border-b border-grey-light',
    categoryTitle:
      'font-sans-light font-medium text-17 lg:text-4xl leading-19 lg:leading-23 pb-15 ',
    categoryWrapper: ' ',
    itemTitle:
      'font-BebasNeueRegular text-black font-normal text-20 py-15 leading-20 md:leading-40 pr-35',
    itemUl: ' pb-20',
    itemLi:
      'mb-5 md:h-auto border-solid border-b border-greyLightest checkbox-container',
    itemLabel: 'flex py-15 checkmark',
    itemCheckbox: 'absolute opacity-0 tags-checkbox',
    itemText:
      'font-HelveticaNeueLight text-16 leading-24  w-11/12  cursor-pointer pr-10',
    chipWrapper: 'inline-block mr-10',
    chip: 'pr-15 font-HelveticaNeueLigh flex text-grey',
    chipLabel: 'pr-10 text-14 text-grey leading-24',
    chipCloseBtn:
      'bg-white rounded-2 no-underline text-center rounded-lg sm:text-22 md:text-22',
    accordion: {
      panel: 'w-full',
      panelHeader: 'w-full relative accordionHeader',
      panelDetail: 'trans-500-max-h p-0 border-0',
      icon: 'absolute right-0 mt-2',
      expanded: 'overflow-hidden',
      collapsed: 'max-h-0 overflow-hidden p-0',
    },
    expandedIcon: 'icon-arrow-down-light font-bold text-2xl',
    collapsedIcon: 'icon-arrow-up-light font-bold text-2xl',
  },
  productListPage: {
    mainWrapper:
      'w-full product-list lg:w-container sm:px-8 md:px-0 lg:mx-auto md:mt-80 md:w-auto md:mx-30',
    breadcrumbWrapper: 'device-full-width lg:px-0 ',
    productviews: '',
    container: 'sm:w-full lg:w-container',
    sectionWrapper: 'flex flex-wrap pb-5',
    headingWrapper: 'w-12/12 pb-30 lg:pb-35 mt-30 md:mt-0 lg:mt-25 px-15',
    heading: 'font-sans text-s22-m40-l48 text-black leading-tighter',
    filterSection: 'hidden md:block md:w-3/12 md:pr-30',
    filterSectionMobile: 'w-12/12 md:hidden px-15 filtersectionbtn relative',
    prodCompareSection: 'w-12/12 md:w-9/12',
    loading:
      'fixed block w-full h-full top-0 bottom-0 left-0 right-0 bg-black opacity-50 z-20 cursor-pointer',
    expandedIcon: 'icon-arrow-down-light font-bold text-2xl',
    collapsedIcon: 'icon-arrow-up-light font-bold text-2xl',
    typeStyle: 'sm:mx-8 md:mx-0 pt-15 pb-10 border-b border-grey-light',
  },
  activeFilter: {
    wrapper: 'w-full flex flex-wrap',
    mainWrapper: 'w-full sm:py-20 md:pt-20 md:pb-6',
    label: '',
    clearBtn: 'text-black text-11 mx-15 underline font-sans',
    rightWrapper: '',
    filterWrapper: 'inline-block',
  },
  accordion: {
    panel: 'w-full',
    panelHeader: 'w-full relative',
    panelDetail: 'trans-500-max-h p-0 md:p-0 sm:px-15',
    icon: 'absolute right-0 mt-1',
    expanded: '',
    collapsed: 'overflow-hidden p-0',
  },
  productCategoryMenu: {
    menuWrapper: 'side-menu-details-reset',
    accordionStyles: {
      accordionWrapper: '',
      accordion: {
        panel: 'w-full',
        panelHeader: 'w-full relative',
        panelDetail: 'trans-500-max-h p-0',
        icon: 'absolute right-0 mt-1',
        expanded: '',
        collapsed: 'max-h-0 overflow-hidden p-0',
      },
    },
    sectionNavStyles: {
      listLink: 'listlinkhere',
      listText: 'listText font-sans-bold text-sm font-normal py-10',
      list: ' ml-20',
      listItem: 'listItemHere sm:py-5 md:py-0',
      listItemText: 'listItemText text-sm font-normal',
      listItemLinkActive: 'font-sans-bold text-sm font-normal ',
    },
  },
  productCompare: {
    compareProductTiles: 'w-1/5 border-grey-light border-r flex flex-col',
    card: {
      mainWrapper: 'bg-white overflow-hidden m-2 md:inline-block relative',
      content: 'text-center',
      media: 'h-16 lg:h-32',
      header: 'font-sans-bold  text-13 text-center text-black',
      close: 'font-sans-bold  text-13',
      button: 'font-sans-bold text-13 btn btn-light text-black',
      title: 'relative mr-20 ',
      toggleCompare:
        'absolute top-0 right-0 opacity-25 hover:opacity-100 text-4xl pl-10',
      mediaWrapper: 'text-center',
      ratingWrapper: 'pt-4',
      rating: 'pl-1 inline-block align-middle pb-1',
      ratingButton: 'text-grey font-sans-roma text-13',
      ratingCount: 'px-3 inline-block align-top',
    },
    drawer: {
      container:
        'compare-tray-container pin-l50 -translate-x50 z-10 lg:m-auto px-15',
      content: 'container',
      contentWrapper: 'w-full flex flex-wrap py-10 md:py-0',
      clearAll: 'hidden md:block text-sm font-sans-roma mb-10',
      compareHeading:
        'hidden md:block text-2xl mb-10 font-sans-bold font-normal',
      compareButton: 'btn btn-solid font-sans-bold text-sm pb-10',
      comparedTiles: 'hidden w-10/12 md:flex px-20',
      downArrow: 'icon-arrow-down hidden md:block cursor-pointer text-2xl',
      upArrow: 'icon-arrow-up-light cursor-pointer text-2xl',
      closeIcon:
        'hidden md:block cursor-pointer ml-5 text-2xl text-black opacity-75 hover:opacity-100',
    },
  },
  productCompareModal: {
    card: {
      mainWrapper:
        'bg-white overflow-hidden m-2 md:m-4 md:inline-block text-center flex flex-col ',
      mainWrapperFullWidth:
        'bg-white overflow-hidden m-2 md:m-4 md:inline-block text-center flex flex-col w-full',
      content: 'text-center pt-4 h-45',
      media: 'mb-20 h-16 md:h-24 lg:h-32',
      header: 'font-sans-bold  text-13 text-center text-black',
      button: 'font-sans-bold text-13 btn btn-light text-black',
      ratingWrapper: 'text-grey font-sans-roma text-13 ',
      'text-with-min-width': 'relative md:h-45 sm:h-85',
    },
    compareProductTiles:
      'text-black text-sm font-sans-bold p-10 border-t align-top ',
    compareProductTilesNoBorder:
      'text-black text-sm font-sans-bold p-10 align-top ',

    compareTitlesNoBold: 'text-sm font-sans border-t p-10',
    compareTitlesNoBoldNoBorder: 'text-sm font-sans-roma border-none p-10',
    compareProductFreeSpace: 'text-sm font-sans border-none h-12',
    comapreProductAttrColumn:
      'registration-privacy-text text-base border-t font-sans-roma p-10 align-top leading-23',
    comapreProductAttrColumnNoBorder:
      'registration-privacy-text text-base font-sans-roma p-10 align-top leading-23 text-center text-13',

    closeButton:
      'bg-white rounded-full leading-normal absolute w-20 right-0 top-0 text-black',
    closeButtonWrapper:
      'fixed absolute right-0 text-base mr-10 w-20 h-8 top-0 mt-20',
    dialogTitle: 'relative bg-black text-white px-20 py-20 text-4xl font-bold',
    dialogWrapper: 'bg-white w-full flex flex-wrap overflow-x-auto',
    dialogWrapperCompleted:
      'bg-white w-full flex flex-wrap overflow-x-auto h-80v overflow-y-auto',
    tableWrapper: 'table-fixed pb-25 px-20 w-11/12 m-auto',
  },
  dialog: {
    mainDiv:
      'buy-now-container bg-white mx-auto my-0 h-full overflow-auto p-15 pb-10 sm:w-11/12 md:w-1/2',
    title: 'relative sm:pb-40 text-black-lighter',
    closeButton: 'absolute right-0 headclose text-40 font-HelveticaNeueLight',
    closeSpan: 'closespan',
    linkContainer: 'buy-now-margin w-1/2 flex mb-15',
    content: 'flex flex-wrap content-start ',
    link: 'w-full flex justify-center px:15 event_buy_now_eretailer_exit',
    actionButtonContainer: 'text-center sm:mt-100 md:mt-0',
    actionButton:
      'actionButton text-center text-grey py-7 px-10 mx-10 border-2 border-grey border-solid',
    applyButton:
      'text-center text-black py-7 px-10 mx-10 border-2 border-black border-solid',
    actionSpan: 'font-BebasNeueRegular text-16 leading-24',
    activeResetStyle: 'activeResetStyle border-black text-black',
  },
  dropDown: {
    wrapper: '',
    categoryTitleWrapper: '',
    categoryTitle:
      'font-sans-light font-medium text-17 lg:text-4xl leading-19 lg:leading-23 pb-15 ',
    categoryWrapper: ' ',
    itemTitle:
      'font-HelveticaNeueLight text-grey font-normal text-16 leading-24 pr-0 sort-droptown-arrow float-left',
    itemUl: '',
    itemLi: 'text-16 font-BebasNeueRegular py-17',
    itemLabel: 'flex py-15 checkmark',
    itemCheckbox: 'absolute opacity-0 tags-checkbox',
    itemText: 'font-BebasNeueRegular text-16 leading-24 w-11/12 cursor-pointer',
    chipWrapper: 'mb-10 inline-block mt-10 mr-10',
    chip: 'py-5 pl-10 pr-15 font-sans-roma flex hover:opacity-75',
    chipLabel: 'pr-1 text-14 text-grey',
    chipCloseBtn:
      'w-4 h-4 bg-white rounded-2 no-underline text-center rounded-lg',
    accordion: {
      panel: 'w-full',
      panelHeader: 'w-full relative accordionHeader',
      panelDetail: 'trans-500-max-h p-0 border-0 relative bg-white',
      icon: 'mt-2 sort-droptown-arrow',
      expanded:
        'max-h-670 overflow-y-auto px-30 py-5 text-right dropdownContainer absolute sm:right-0 md:pin-r10 z-3',
      collapsed: 'max-h-0 overflow-hidden absolute',
    },
    expandedIcon: 'icon-arrow-down-light font-bold text-2xl sort-dropdown',
    collapsedIcon: 'icon-arrow-up-light font-bold text-2xl sort-dropdown',
  },
  hairAdvisor: 'hair-care-section fixed bottom-0 right-0 mr-10 mb-0 z-4 ',
  ieLoadMoreDiv: 'flex justify-center pt-60',
  ieLoadMoreBtn:
    'border-solid border-black rounded-none border-2 sm:text-5.2v md:text-20 px-30 py-12  sm:my-34 md:mt-0 md:mb-0 sm:inline-block md:relative font-BebasNeueRegular no-underline text-black get-started font-bold tracking-wider11x ',
};
